export const THEME_DIR = '/wp-content/themes/starwarps-2026/';
export const ART_DIRECTORY = `${THEME_DIR}public/images/art/`;

export const DEFAULT_PIECE = 'about';

export const INDEX_PAGE_SIZE = 100;

export const INDEX_SEARCH_KEYS = ['title', 'artist', 'medium'];

export const TIME_BEFORE_UI_FADES = 5000;

export const WORKS_JSON_FILE = `${THEME_DIR}data/starworks2017.json`;
export const ARTISTS_JSON_FILE = `${THEME_DIR}data/artists.json`;

export const FETCH_OPTS = {
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	},
	credentials: 'same-origin'
}

export const INVERT_STARFIELD = true;
export const RANDOM_STAR_COLOR_EVERY = 10;

export const AUTO_TIME = 10000;

export const LOADING_STARS = 100;

export const ADDITIONS_RANDOM_BORDERS = false;
export const ADDITIONS_MAX_BORDER_WIDTH = 50;
export const SCROLLING_ELEMENT = 'frame';

export const ROUTES = {
	THANKYOU: 'THANKYOU',
	GRID: 'GRID',
	INDEX: 'INDEX',
	GALLERY: 'GALLERY',
	ADDITIONS: 'ADDITIONS'
}